import { FullLocaleData } from '../locale.types';

export default {
  abbr: 'el-GR',
  exception: {
    403: `Λυπούμαστε, δεν έχετε πρόσβαση σε αυτήν τη σελίδα`,
    404: `Λυπούμαστε, η σελίδα αυτή δεν βρέθηκε`,
    500: `Λυπούμαστε, σφάλμα διακομιστή`,
    backToHome: 'Επιστροφή στην αρχική σελίδα',
  },
  noticeIcon: {
    emptyText: 'Δεν υπάρχουν δεδομένα',
    clearText: 'Καθαρισμός',
  },
  reuseTab: {
    close: 'Κλείσιμο καρτέλας',
    closeOther: 'Κλείσιμο των άλλων καρτέλων',
    closeRight: 'Κλείσιμο των καρτελών δεξιά',
    clear: 'Καθαρισμός καρτελών',
  },
  tagSelect: {
    expand: 'Επέκταση',
    collapse: 'Σύμπτυξη',
  },
  miniProgress: {
    target: 'Στόχος: ',
  },
  st: {
    total: '{{range[0]}} - {{range[1]}} από {{total}}',
    filterConfirm: 'ΟΚ',
    filterReset: 'Επαναφορά',
  },
  sf: {
    submit: 'Υποβολή',
    reset: 'Επαναφορά',
    search: 'Αναζήτηση',
    edit: 'Αποθήκευση',
    addText: 'Προσθήκη',
    removeText: 'Αφαίρεση',
    checkAllText: 'Επιλογή όλων',
    error: {
      'false schema': `Boolean schema is false`,
      $ref: `Can't resolve reference {ref}`,
      additionalItems: `Should not have more than {limit} item`,
      additionalProperties: `Should not have additional properties`,
      anyOf: `Should match some schema in "anyOf"`,
      dependencies: `should have property {deps} when property {property} is present`,
      enum: `Should be equal to one of predefined values`,
      format: `Should match format "{format}"`,
      type: `Should be {type}`,
      required: `Required`,
      maxLength: `Should not be longer than {limit} character`,
      minLength: `Should not be shorter than {limit} character`,
      minimum: `Should be {comparison} {limit}`,
      formatMinimum: `Should be {comparison} {limit}`,
      maximum: `Should be {comparison} {limit}`,
      formatMaximum: `Should be {comparison} {limit}`,
      maxItems: `Should not have more than {limit} item`,
      minItems: `Should not have less than {limit} item`,
      maxProperties: `Should not have more than {limit} property`,
      minProperties: `Should not have less than {limit} property`,
      multipleOf: `Should be a multiple of {multipleOf}`,
      not: `Should not be valid according to schema in "not"`,
      oneOf: `Should match exactly one schema in "oneOf"`,
      pattern: `Should match pattern "{pattern}"`,
      uniqueItems: `Should not have duplicate items (items ## {j} and {i} are identical)`,
      custom: `Should match format`,
      propertyNames: `Property name "{propertyName}" is invalid`,
      patternRequired: `Should have property matching pattern "{missingPattern}"`,
      switch: `Should pass "switch" keyword validation, case {caseIndex} fails`,
      const: `Should be equal to constant`,
      contains: `Should contain a valid item`,
      formatExclusiveMaximum: `formatExclusiveMaximum should be boolean`,
      formatExclusiveMinimum: `formatExclusiveMinimum should be boolean`,
      if: `Should match "{failingKeyword}" schema`,
    },
  },
} as FullLocaleData;
